module.exports = __webpack_public_path__ + "img/accesoires-huitres-en-ligne-boutrais.6c262cec.png";